import api from './index'
import request from '@/utils/request'
/**
 * @description hidePhoneNum方法提供给页面调用
 */
export function cashierDetail (data) {
  return request({
    url: `${api.cashierDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 重置密码事件
 */
export function resetSubCashier (data) {
  return request({
    url: `${api.resetSubCashier}`,
    method: 'post',
    data
  })
}
/**
 * @description 冻结/解冻事件
 */
export function freezeCashier (data) {
  return request({
    url: `${api.freezeCashier}`,
    method: 'post',
    data
  })
}
/**
 * @description 冻结/解冻事件
 */
export function unfreezeCashier (data) {
  return request({
    url: `${api.unfreezeCashier}`,
    method: 'post',
    data
  })
}
/**
 * @description 注销用户事件
 */
export function deleteCashier (data) {
  return request({
    url: `${api.deleteCashier}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取用户信息列表方法
 */
export function listCashierAc (data) {
  return request({
    url: `${api.listCashierAc}`,
    method: 'post',
    data
  })
}
/**
 * @description
 */
export function cashierName (params) {
  return request({
    url: `${api.cashierName}`,
    method: 'get',
    params
  })
}
/**
 * @description 检测账号可用性
 */
export function validateCashierAc (data) {
  return request({
    url: `${api.validateCashierAc}`,
    method: 'post',
    data
  })
}
/**
 * @description 新增收银员
 */
export function addCashierAc (data) {
  return request({
    url: `${api.addCashierAc}`,
    method: 'post',
    data
  })
}
/**
 * @description 编辑
 */
export function updateCashierAc (data) {
  return request({
    url: `${api.updateCashierAc}`,
    method: 'post',
    data
  })
}
